export default "__VITE_ASSET__B168WH18__"